module.exports = __webpack_public_path__ + "static/media/label-blue.a1bb1efc.svg";